export default __webpack_public_path__ + "static/IBMPlexSans-SemiBoldItalic-Latin2-e53170228888234053379f0291327598.woff2";